import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { WebSocketProvider } from "./contexts/WebSocketContext"; // 👈 جدید
import AppRouter from "./routes/AppRouter";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./axiosConfig";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Toaster position="top-center" containerStyle={{ zIndex: 999999 }} />

      <BrowserRouter>
        <AuthProvider>
          <WebSocketProvider>
            <AppRouter />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={true}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </WebSocketProvider>{" "}
          {/* 👈 جدید */}
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
